"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../utils");
var _reactBlueprintLibrary = require("react-blueprint-library");
var _reactBootstrap = require("react-bootstrap");
var _lodash = require("lodash");
var _richTextField = require("../../lib/richTextField");
var _LoadableComponent = _interopRequireDefault(require("../../components/LoadableComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// import HorizontalCard from '../HorizontalCard/index';
// import Accordion from '../Accordion/index';
/**
 *  A react component to create a tab navigation
 *
 * @param {object} props The properties passed into the object
 * @param {object} props.rendering Fields to render
 * @param {object} props.rendering.fields Fields
 *
 * @returns {React.ReactElement} A tab navigation
 */
function TabNavHorizontal(props) {
  var extractedFields,
    tabAlignment,
    componentParam,
    showTab = false;
  var getURLQuery = new URLSearchParams(props.params.pageQuery);
  var tabIndex = getURLQuery.get('tab');
  var TabContent = props => {
    if (props.IsContentDynamic.value) {
      if (!(0, _lodash.isEmpty)(props.ContentMainDynamic)) return /*#__PURE__*/_react.default.createElement(TabContentDynamic, props);else return null;
    } else return /*#__PURE__*/_react.default.createElement(TabContentStatic, props);
  };
  var TabContentDynamic = props => {
    var sideColumnSize = (0, _lodash.isEmpty)(props.ContentSideDynamic) ? 0 : (0, _lodash.toSafeInteger)((0, _lodash.get)(props.SideColumnSize, 'value', '4'));
    var mainColSize = 12 - sideColumnSize;
    if (sideColumnSize > 0) {
      if (props.SideColumnDirection.value === 'left') {
        var _props$ContentSideDyn, _props$ContentMainDyn;
        return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, LoadDynamicColumn(sideColumnSize, (_props$ContentSideDyn = props.ContentSideDynamic.fields.ComponentName) === null || _props$ContentSideDyn === void 0 ? void 0 : _props$ContentSideDyn.value, props.ContentSideDynamic), LoadDynamicColumn(mainColSize, (_props$ContentMainDyn = props.ContentMainDynamic.fields.ComponentName) === null || _props$ContentMainDyn === void 0 ? void 0 : _props$ContentMainDyn.value, props.ContentMainDynamic));
      } else {
        var _props$ContentMainDyn2, _props$ContentSideDyn2;
        return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, LoadDynamicColumn(mainColSize, (_props$ContentMainDyn2 = props.ContentMainDynamic.fields.ComponentName) === null || _props$ContentMainDyn2 === void 0 ? void 0 : _props$ContentMainDyn2.value, props.ContentMainDynamic), LoadDynamicColumn(sideColumnSize, (_props$ContentSideDyn2 = props.ContentSideDynamic.fields.ComponentName) === null || _props$ContentSideDyn2 === void 0 ? void 0 : _props$ContentSideDyn2.value, props.ContentSideDynamic));
      }
    } else {
      var _props$ContentMainDyn3;
      return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, LoadDynamicColumn(mainColSize, (_props$ContentMainDyn3 = props.ContentMainDynamic.fields.ComponentName) === null || _props$ContentMainDyn3 === void 0 ? void 0 : _props$ContentMainDyn3.value, props.ContentMainDynamic));
    }
  };
  function LoadDynamicColumn(colSize, componentName, rendering) {
    return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
      md: colSize
    }, /*#__PURE__*/_react.default.createElement(_LoadableComponent.default, {
      name: componentName,
      rendering: rendering,
      params: componentParam,
      parentComponent: "tab"
    }));
  }
  var TabContentStatic = props => {
    return (0, _richTextField.parseHTML)(props.ContentStatic);
  };
  if (props.rendering.fields) {
    extractedFields = (0, _utils.extractFieldsFn)(props);
    tabAlignment = extractedFields.TabCenterAligned.value ? 'nav-tabs-center-align' : '';
    showTab = extractedFields.ShowSingleTab.value ? true : extractedFields.Tabs.length > 1;
    componentParam = props.params;
    if (showTab) {
      var titleDiv = (titleString, iconClass) => {
        if ((0, _lodash.isEmpty)(iconClass)) return titleString;else {
          return /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("div", {
            className: "row"
          }, /*#__PURE__*/_react.default.createElement("span", {
            className: "".concat(iconClass, " icon-lg col-12 mm-desktop-tablet-only")
          })), titleString);
        }
      };
      return /*#__PURE__*/_react.default.createElement("div", {
        id: (0, _utils.getComponentContentId)(props.rendering.dataSource),
        className: 'app-container ' + tabAlignment
      }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Tabs, {
        defaultKey: tabIndex === null || tabIndex > extractedFields.Tabs.length - 1 || isNaN(tabIndex) ? '0' : tabIndex
      }, extractedFields.Tabs.map((tabList, key) => {
        return /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Tabs.Tab, {
          eventKey: key,
          key: key,
          title: titleDiv(tabList.fields.Title.value, tabList.fields.Icon.value)
        }, /*#__PURE__*/_react.default.createElement(TabContent, tabList.fields));
      })));
    } else {
      return /*#__PURE__*/_react.default.createElement("div", {
        id: (0, _utils.getComponentContentId)(props.rendering.dataSource)
      }, /*#__PURE__*/_react.default.createElement(TabContent, extractedFields.Tabs[0].fields));
    }
  } else return null;
}
var _default = exports.default = TabNavHorizontal;